import { MOBILE_NAV_QUERY } from '@/components/layout/nav/primaryRoutes';

// The URL this page load started on, read when the router module loads. Event mode may redirect
// only that first landing, and only once: any later visit to `/` is the rep choosing home.
let boot = typeof window === 'undefined' ? null : { pathname: window.location.pathname, search: window.location.search };
let consumed = false;

export function coldLandingOpen(): boolean {
  return !consumed && boot?.pathname === '/' && !boot.search;
}

export function consumeColdLanding(): void {
  consumed = true;
}

export function resetColdLandingForTests(pathname: string, search = ''): void {
  boot = { pathname, search };
  consumed = false;
}

const PHONE_SHORT_SIDE_PX = 768;
const matches = (query: string) => typeof window !== 'undefined' && typeof window.matchMedia === 'function' && window.matchMedia(query).matches;

// Event mode is for the floor rep's phone only: managers work quotes on laptops. A phone is the
// width that already gets the phone event workspace, or the installed app on a touch device
// whose short side is phone-sized (a phone held sideways is wider than that breakpoint).
export function phoneViewport(): boolean {
  if (matches(MOBILE_NAV_QUERY)) return true;
  if (!matches('(display-mode: standalone)') || !matches('(pointer: coarse)')) return false;
  return Math.min(window.screen.width, window.screen.height) < PHONE_SHORT_SIDE_PX;
}
